export default function CustomContent({ action, onSubmit }) {

  return (
    <>
      <div className="custom-content" dangerouslySetInnerHTML={{ __html: action.config.content }} />
      { action.config.skipButton &&
        <button
          className="button custom-skip-button"
          onClick={() => onSubmit({ skip: true })}
        >
          {action.config.skipButtonText}
        </button>
      }
    </>
  )
}
